import { LibraryRequest } from "../actions/library_request.js";
export class ApplicationActions extends LibraryRequest {
    constructor(library, client, provider) {
        super(library, client, provider);
    }
    async isChainAbstractionCompatible(appDomainUrl) {
        const { isChainAbstractionCompatible, code, message } = await this.sendRequest("orby_isChainAbstractionCompatible", [{ appDomainUrl }]);
        if (code && message) {
            console.error("[isChainAbstractionCompatible]", code, message);
            return undefined;
        }
        return isChainAbstractionCompatible;
    }
}
